import React, { useRef, useState, useEffect, useCallback } from "react";
import header_icon from "../../assets/image/svg/home_icon_black.svg";
import header_sky_icon from "../../assets/image/png/home_icon2.png";
import header_trainig_icon from "../../assets/image/png/home_icon3.png";
import header_job_icon from "../../assets/image/png/home_icon4.png";
import icon from "../../assets/image/png/icon.svg";
import ic_profile from "../../assets/image/png/ic_profilepage.svg";
import MenuIcon from "@mui/icons-material/Menu";
import iclist from "../../assets/image/png/iclist.svg";
import Isdrone from "../../assets/image/png/ISdronestore.svg";
import icdrone from "../../assets/image/png/ic_droneparts.svg";
import iSstore from "../../assets/image/png/iSstore.svg";
import Logo from "../../assets/image/png/DronePlanet_Logo-removebg.png";
import { Link, useNavigate } from "react-router-dom";
import { Dropdown, Modal, Spinner } from "react-bootstrap";
import { FaArrowUp, FaArrowRight } from "react-icons/fa6";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { handleLoginPopup } from "../../redux/slice/userSlice";
import userIcon from "../../assets/image/svg/userIcon.svg";
import CartIcon from "../../assets/image/svg/cartIcon.svg";
import { FaGoogle, FaApple, FaMicrosoft } from "react-icons/fa";
import {
  AppRegistration,
  CloudQueue,
  FlightTakeoff,
  Gavel,
  Style,
} from "@mui/icons-material";
import DescriptionIcon from "@mui/icons-material/Description";
import GoogleIcon from "@mui/icons-material/Google";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { TbDrone } from "react-icons/tb";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
} from "@mui/material";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import Slide from "@mui/material/Slide";
import {
  Home,
  ExpandLess,
  ExpandMore,
  Lock,
  Flight,
  Work,
  Logout,
  Login,
  Explore,
  ShoppingCart,
  Close,
} from "@mui/icons-material";
import { PiDroneFill } from "react-icons/pi";
import {
  Button,
  Menu,
  MenuItem,
  Avatar,
  Divider,
  Typography,
  Grid,
  useMediaQuery,
  useTheme,
  styled,
  IconButton,
  Collapse,
} from "@mui/material";
import {
  AccountCircle,
  ShoppingBag,
  ExitToApp,
  Business,
  Build,
  Store,
  Cloud,
  Assignment,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Settings,
} from "@mui/icons-material";

const StyledMenu = styled(Menu)({
  "& .MuiPaper-root": {
    transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important",
  },
});

const StyledDrawer = styled(Drawer)(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    width: 280,
    backgroundColor: "#fff",
    transform: open ? "translateX(0)" : "translateX(100%)",
    transition: theme.transitions.create("transform", {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.standard,
    }),
  },
}));

const Navbar = () => {
  const [storeOpen, setStoreOpen] = useState(false);
  const [trainingOpen, setTrainingOpen] = useState(false);
  const [serviceOpen, setServiceOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cartCount = useSelector((state) => state.user.cartCount);
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [showRegisterForm, setShowRegisterForm] = useState(false);
  const [showSignInModal, setShowSignInModal] = useState(false);
  const { showLogin } = useSelector((state) => state.user);
  const [userInput, setUserInput] = useState("");
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [newuserInfo, setNewuserInfo] = useState({
    phoneNumber: Number,
    name: "",
    email: "",
    city: "",
    state: "",
  });
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [newUserInfo, setNewUserInfo] = useState({
    phoneNumber: "",
    city: "",
    state: "",
  });
  const [currentUserId, setCurrentUserId] = useState(null);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [scrolled, setScrolled] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const inputRefs = useRef([]);
  const isLogin = Cookies.get("token");
  const [menuOpen, setMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const timeoutRef = useRef(null);
  const toastRef = useRef(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const showToast = (message, type = "success") => {
    if (!toastRef.current) {
      toastRef.current =
        type === "success"
          ? toast.success(message, {
              onClose: () => {
                toastRef.current = null;
              },
            })
          : toast.error(message, {
              onClose: () => {
                toastRef.current = null;
              },
            });
    }
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuClick = (action) => {
    handleDropdownItemClick(action);
    handleClose();
  };

  const clientId =
    "1035828083834-jpg1cpgbohte4d7pihk5sooubprv8im2.apps.googleusercontent.com";

  const [userFirstName, setUserFirstName] = useState(null);

  const handleGoogleLoginSuccess = async (response) => {
    try {
      if (!response.credential) {
        return toast.error("Google token not received");
      }

      const googleToken = response.credential;

      const resp = await axios.post(process.env.REACT_APP_API_URL + "/login", {
        token: googleToken,
      });

      if (resp?.data?.success) {
        localStorage.setItem("authToken", resp?.data?.token);
        localStorage.setItem("user", JSON.stringify(resp?.data?.user));

        Cookies.set("user", resp?.data?.user?.name, { expires: 1 });
        Cookies.set("token", resp?.data?.token, { expires: 1 });
        Cookies.set("userId", resp?.data?.user?._id, { expires: 1 });

        setCurrentUserId(resp?.data?.user?._id);

        if (resp?.data?.isNewUser) {
          // 👇 open modal for new users
          setShowDetailsModal(true);
        } else {
          toast.success(`Welcome back ${resp?.data?.user?.name}`);
          setShowSignInModal(false);
          window.location.reload();
        }
      } else {
        toast.error(resp?.data?.message);
      }
    } catch (err) {
      console.error("Google Login Error:", err);
      toast.error("Google login failed...");
    }
  };

  const handleGoogleLoginFailure = (error) => {
    console.error("Google Login Failed:", error);
    toast.error("Google login was unsuccessful.");
  };

  const handleChange = (index, event) => {
    const newOtp = [...otp];
    newOtp[index] = event.target.value.slice(0, 1);
    setOtp(newOtp);
    if (event.target.value !== "" && index < otp.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleBackspace = (index, event) => {
    if (event.keyCode === 8 && index > 0 && otp[index] === "") {
      inputRefs.current[index - 1].focus();
    }
  };

  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  };

  const handleSignInModal = () => {
    setShowSignInModal(false);
    setShowOtpInput(false);
    setUserInput("");
    setOtp(["", "", "", ""]);
    setIsOtpSent(false);
    setShowRegisterForm(false);
    dispatch(handleLoginPopup(false));
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (showLogin) {
      setShowSignInModal(true);
    }
  }, [showLogin]);

  const handleContinue = useCallback(
    async (e, type = 1, googleToken = null) => {
      e.preventDefault();
      try {
        setIsLoading(true);

        if (googleToken) {
          const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/login`,
            { token: googleToken },
          );
          setIsLoading(false);

          if (response?.data?.success) {
            localStorage.setItem("authToken", response?.data?.token);
            localStorage.setItem("user", JSON.stringify(response?.data?.user));
            navigate("/home");
          } else {
            showToast(response?.data?.message, "error");
          }
        } else {
          if (isValidPhoneNumber(userInput)) {
            const response = await axios.post(
              `${process.env.REACT_APP_API_URL}/login`,
              {
                phoneNumber: userInput,
                token: isLogin,
              },
            );
            setIsLoading(false);

            if (response?.data?.status === "success") {
              setShowOtpInput(true);
              if (!isOtpSent) {
                showToast("OTP sent successfully.", "success");
                setIsOtpSent(true);
              }
            } else {
              showToast(response?.data?.message, "error");
            }
          } else {
            setIsLoading(false);
            showToast(
              "Invalid phone number! Please enter a valid 10-digit number.",
              "error",
            );
          }
        }
      } catch (error) {
        setIsLoading(false);
        showToast("Something went wrong!", "error");
      }
    },
    [userInput, isOtpSent, isLogin, navigate],
  );
  const isValidPhoneNumber = (phoneNumber) => {
    const phoneRegex = /^[6-9]\d{9}$/;
    return phoneRegex.test(phoneNumber);
  };

  const handlePhoneNumberChange = (e) => {
    const inputPhoneNumber = e.target.value.replace(/\D/g, "");
    if (inputPhoneNumber.length <= 10) {
      setUserInput(inputPhoneNumber);
      setNewuserInfo({ ...newuserInfo, phoneNumber: inputPhoneNumber });
    }
  };

  const handleCartIconClick = () => {
    if (!isLogin) {
      dispatch(handleLoginPopup(true));
    } else {
      navigate("/cart");
    }
  };

  const verifyOtpHandle = async (e) => {
    try {
      setIsLoading(true);
      e.preventDefault();
      const combinedOtp = otp.join("");
      if (combinedOtp.length !== 4) {
        toast.error("Enter a valid OTP");
        setIsLoading(false);
        return;
      }

      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/verifyOtp",
        { phoneNumber: userInput, otp: combinedOtp },
      );
      setIsLoading(false);
      if (response?.data?.status === "success") {
        const newUser = response?.data?.data?.newUser;
        if (newUser) {
          setShowRegisterModal(true);
          setShowRegisterForm(true);
          setShowSignInModal(false);
          setShowOtpInput(false);
          dispatch(handleLoginPopup(false));
        } else {
          setShowSignInModal(false);
          Cookies.set("user", response?.data?.data?.user?.name, { expires: 1 });
          Cookies.set("token", response?.data?.data?.token, { expires: 1 });
          Cookies.set("userId", response?.data?.data?.user?._id, {
            expires: 1,
          });
          toast.success(response?.data?.message);
          window.location.reload();
        }
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      setIsLoading(false);
      toast.error("Something went wrong!");
    }
  };

  const addUser = async () => {
    const { name, email, city, state } = newuserInfo;
    if (!name || !email || !city || !state) {
      toast.error("Please enter all fields");
      return;
    }
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/registration",
        newuserInfo,
      );
      if (response.status === 200) {
        setShowRegisterModal(false);
        setShowSignInModal(false);
        setShowOtpInput(false);
        Cookies.set("user", response?.data?.data?.user?.name, { expires: 1 });
        Cookies.set("token", response?.data?.data?.token, { expires: 1 });
        Cookies.set("userId", response?.data?.data?.user?._id, { expires: 1 });
        toast.success(response?.data?.message);
        setUserInput("");
        window.location.reload();
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
    }
  };

  const userName = Cookies.get("user");
  const getFirstName = (fullName) => {
    return fullName ? fullName.split(" ")[0] : "";
  };

  const firstName = getFirstName(userName);

  const handleRegisterModal = () => {
    setShowRegisterForm(true);
    setShowSignInModal(false);
  };

  const handleLogout = () => {
    Cookies.remove("user");
    Cookies.remove("token");
    Cookies.remove("userId");
    toast.success("Logged out successfully!");
    window.location.reload();
  };

  const handleDropdownItemClick = (action) => {
    if (!isLogin) {
      dispatch(handleLoginPopup(true));
    } else {
      switch (action) {
        case "account":
          navigate("/account");
          break;
        case "orders":
          navigate("/orders");
          break;
        case "logout":
          handleLogout();
          break;
        default:
          break;
      }
    }
  };

  const handleMouseEnter = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setIsHovering(true);
  }, []);

  const handleMouseLeave = () => {
    setIsDropdownOpen(false);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <nav className={`fixed-navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="homepage">
        {/* <ToastContainer /> */}
        <Modal
          show={showSignInModal}
          onHide={handleSignInModal}
          centered
          contentClassName="border-0 rounded-4 shadow-lg bg-light "
        >
          <Modal.Header
            className="border-0 pb-0"
            closeButton
            closeVariant="black"
            style={{ backgroundColor: "transparent" }}
          ></Modal.Header>

          <Modal.Body
            className="px-4 pb-4 d-flex flex-column"
            style={{ height: "100%" }}
          >
            <form
              className="d-flex flex-column justify-content-between flex-grow-1"
              style={{ height: "100%" }}
              onSubmit={showOtpInput ? verifyOtpHandle : handleContinue}
            >
              {/* Scrollable content */}
              <div
                className="flex-grow-1 overflow-auto"
                style={{ minHeight: 0 }}
              >
                <h1
                  className="text-center fw-bold"
                  style={{
                    fontSize: "2rem",
                    // background: 'linear-gradient(45deg, #4b6cb7, #182848)',
                    WebkitBackgroundClip: "text",
                    color: "#113C65",
                  }}
                >
                  Welcome
                </h1>

                <h4
                  className="fw-semibold text-center text-muted mb-4"
                  style={{ fontSize: "1rem" }}
                >
                  Sign in to continue
                </h4>

                {showOtpInput && (
                  <p className="fs-6 text-center text-secondary">
                    Enter the OTP sent to{" "}
                    <span className="fw-bold">{userInput}</span>
                  </p>
                )}

                <div className="text-center mt-4">
                  {showOtpInput ? (
                    <div
                      className="d-flex justify-content-center gap-2"
                      style={{ maxWidth: "320px", margin: "0 auto" }}
                    >
                      {otp.map((value, index) => (
                        <input
                          key={index}
                          ref={(el) => (inputRefs.current[index] = el)}
                          className="form-control text-center fw-bold fs-4 border rounded-3 shadow-sm"
                          style={{
                            width: "50px",
                            height: "55px",
                            outline: "none",
                            boxShadow: "0 0 0 1px rgba(0,0,0,0.05)",
                          }}
                          type="number"
                          maxLength={1}
                          value={value}
                          onKeyUp={(event) => handleBackspace(index, event)}
                          onChange={(event) => handleChange(index, event)}
                        />
                      ))}
                    </div>
                  ) : (
                    <>
                      <input
                        className="form-control rounded-5 py-2 px-3 mt-3 shadow-sm"
                        style={{
                          border: "1px solid #dee2e6",
                          fontSize: "1rem",
                        }}
                        type="text"
                        placeholder="Enter Mobile Number"
                        value={userInput}
                        onChange={(e) => handlePhoneNumberChange(e)}
                      />
                      {!isValidPhoneNumber(userInput) &&
                        userInput.length > 0 && (
                          <p className="text-danger small mt-1">
                            Please enter a valid 10-digit phone number.
                          </p>
                        )}
                    </>
                  )}

                  <p className="small text-muted mt-3">
                    {showOtpInput ? (
                      <>
                        Didn’t get the OTP?
                        <span
                          className="fw-bold text-primary cursor-pointer ms-1"
                          onClick={(e) => handleContinue(e, 2)}
                          style={{ cursor: "pointer" }}
                        >
                          Resend
                        </span>
                      </>
                    ) : (
                      "You’ll receive a verification code via SMS."
                    )}
                  </p>

                  {/* Google Login */}
                  {!showOtpInput && (
                    <>
                      {/* Divider text */}
                      <div className="d-flex align-items-center my-3">
                        <hr className="flex-grow-1" />
                        <span className="mx-2 text-muted small">
                          Or continue with Google
                        </span>
                        <hr className="flex-grow-1" />
                      </div>

                      {/* Google Button */}
                      <div className="mt-2 d-flex justify-content-center">
                        <GoogleOAuthProvider clientId={clientId}>
                          <GoogleLogin
                            onSuccess={handleGoogleLoginSuccess}
                            onError={handleGoogleLoginFailure}
                            width="320"
                            shape="pill"
                            size="large"
                            text="signin_with"
                          />
                        </GoogleOAuthProvider>
                      </div>
                    </>
                  )}
                  {/* CSC Login */}
                  {/* <div className="mt-3 d-flex justify-content-center">
  <button
    type="button"
    onClick={() => {
      window.location.href = "http://localhost:6002/auth/csc";
    }}
    className="btn w-100 rounded-pill fw-semibold"
    style={{
      maxWidth: "320px",
      border: "1px solid #113C65",
      color: "#113C65",
      background: "#fff",
      padding: "10px",
    }}
  >
    Login with CSC
  </button>
</div> */}
                </div>
              </div>

              {/* Button pinned at bottom */}
              <div className="text-center mt-4">
                <button
                  className="btn btn-primary w-100 py-2 rounded-3 fw-semibold shadow-sm"
                  type="submit"
                  style={{
                    fontSize: "1.1rem",
                    background: "linear-gradient(45deg, #4b6cb7, #182848)",
                    border: "none",
                  }}
                >
                  {!isLoading ? (
                    <>
                      Continue <FaArrowRight className="ms-1" />
                    </>
                  ) : (
                    <Spinner animation="border" role="status" size="sm">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  )}
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>

        <Modal
          show={showRegisterModal}
          onHide={() => setShowRegisterModal(false)}
        >
          <Modal.Body
            className="px-4 pb-4 d-flex flex-column"
            style={{ height: "100%" }}
          >
            <form
              className="d-flex flex-column justify-content-between flex-grow-1"
              style={{ height: "100%" }}
              onSubmit={(e) => e.preventDefault()}
            >
              {/* Scrollable content */}
              <div
                className="flex-grow-1 overflow-auto"
                style={{ minHeight: 0 }}
              >
                <h4 className="fw-bold ff_inter custom_size color_darkgray">
                  Sign Up
                </h4>

                <div className="mt-3">
                  <label htmlFor="name">Name</label>
                  <input
                    className="custom_input rounded-2 py-2 px-3 w-100"
                    type="text"
                    placeholder="Enter Your Name"
                    value={newuserInfo.name}
                    onChange={(e) =>
                      setNewuserInfo({ ...newuserInfo, name: e.target.value })
                    }
                  />
                </div>

                <div className="mt-4">
                  <label htmlFor="mail">Mail</label>
                  <input
                    className="custom_input rounded-2 py-2 px-3 w-100"
                    type="email"
                    placeholder="Enter Your Mail"
                    value={newuserInfo.email}
                    onChange={(e) =>
                      setNewuserInfo({ ...newuserInfo, email: e.target.value })
                    }
                  />
                </div>

                <div className="mt-4">
                  <label htmlFor="city">City</label>
                  <input
                    className="custom_input rounded-2 py-2 px-3 w-100"
                    type="text"
                    placeholder="Enter Your City"
                    value={newuserInfo.city}
                    onChange={(e) =>
                      setNewuserInfo({ ...newuserInfo, city: e.target.value })
                    }
                  />
                </div>

                <div className="mt-4">
                  <label htmlFor="state">State</label>
                  <input
                    className="custom_input rounded-2 py-2 px-3 w-100"
                    type="text"
                    placeholder="Enter Your State"
                    value={newuserInfo.state}
                    onChange={(e) =>
                      setNewuserInfo({ ...newuserInfo, state: e.target.value })
                    }
                  />
                </div>
              </div>

              {/* Fixed button at bottom */}
              <div className="text-center mt-4">
                <button
                  className="tab_btn w-100 border-0 py-2 rounded-2 fs_21 fw-semibold ff_inter text-white"
                  onClick={addUser}
                >
                  {!isLoading ? (
                    <>
                      Continue <FaArrowRight />
                    </>
                  ) : (
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  )}
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>

        <div className="container custom_container">
          <div className="d-flex align-items-center justify-content-between">
            <Link to="/" onClick={scrollToTop}>
              <span className="d-flex align-items-center fs_37 fw-bold ff_raleway text-white">
                <img width={210} src={Logo} alt="Enlist your Organisation" />
              </span>
            </Link>
            <div className="d-flex align-items-center gap-3">
              <div className="d-lg-flex d-none align-items-center gap-2">
                <div className="d-flex align-items-center">
                  <Dropdown>
                    <Link to="/" onClick={scrollToTop}>
                      <Dropdown.Toggle
                        className="bg-transparent border-0 change text-black fs_15"
                        id="dropdown-basic"
                      >
                        Home
                      </Dropdown.Toggle>
                    </Link>
                  </Dropdown>
                </div>
                <div className="d-flex align-items-center">
                  <Link to="/dsk">
                    <Dropdown>
                      <Dropdown.Toggle
                        className="bg-transparent border-0 change text-black fs_15"
                        id="dropdown-basic"
                      >
                        DSK
                      </Dropdown.Toggle>
                    </Dropdown>
                  </Link>
                </div>
                <div className="d-flex align-items-center">
                  <Link to="/drone-city">
                    <Dropdown>
                      <Dropdown.Toggle
                        className="bg-transparent border-0 change text-black fs_15"
                        id="dropdown-basic"
                      >
                        Drone City
                      </Dropdown.Toggle>
                    </Dropdown>
                  </Link>
                </div>
                <div className="d-flex align-items-center">
                  <Dropdown>
                    <Dropdown.Toggle
                      className="bg-transparent border-0 text-black fs_15 p-2 hover-underline"
                      id="dropdown-store"
                    >
                      Marketplace
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="mt-2 p-2 border-0 shadow-lg rounded-3">
                      <Dropdown.Item
                        as={Link}
                        to="/product/all-drone"
                        className="d-flex gap-3 px-4 py-3 align-items-center text-dark hover-bg-light hover-text-primary transition-all"
                      >
                        <i className="fas fa-shopping-cart fs-6"></i>
                        Buy Drones
                      </Dropdown.Item>
                      <Dropdown.Item
                        as={Link}
                        to="/drone-parts"
                        className="d-flex gap-3 px-4 py-3 align-items-center text-dark hover-bg-light hover-text-primary transition-all"
                      >
                        <i className="fas fa-cog fs-6"></i>
                        Buy Drone Parts
                      </Dropdown.Item>
                      <Dropdown.Item
                        as={Link}
                        to="/intellegence-market-solutions"
                        className="d-flex gap-3 px-4 py-3 align-items-center text-dark hover-bg-light hover-text-primary transition-all"
                      >
                        <i class="fa fa-desktop" aria-hidden="true"></i>
                        SaaS
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                {/* hidden for payment gateway */}
                <div className="d-flex align-items-center">
                  <Dropdown>
                    <Dropdown.Toggle
                      className="bg-transparent border-0 text-black fs_15 p-2 hover-underline"
                      id="dropdown-basic"
                    >
                      Training
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="mt-2 p-2 border-0 shadow-lg rounded-3">
                      <Dropdown.Item
                        as={Link}
                        to="/training-courses/0"
                        className="d-flex gap-3 px-4 py-3 align-items-center text-dark hover-bg-light hover-text-primary transition-all"
                      >
                        <i className="fas fa-book-open fs-6"></i>
                        Drone Training Courses
                      </Dropdown.Item>
                      <Dropdown.Item
                        as={Link}
                        to="/training-courses/1"
                        className="d-flex gap-3 px-4 py-3 align-items-center text-dark hover-bg-light hover-text-primary transition-all"
                      >
                        <i className="fas fa-university fs-6"></i>
                        Drone Training Institute
                      </Dropdown.Item>
                      <Dropdown.Item
                        as={Link}
                        to="/training-courses/2"
                        className="d-flex gap-3 px-4 py-3 align-items-center text-dark hover-bg-light hover-text-primary transition-all"
                      >
                        <i class="fa fa-wrench" aria-hidden="true"></i>
                        Deeptech Workshops
                      </Dropdown.Item>
                      <Dropdown.Item
                        as={Link}
                        to="/training-courses/3"
                        className="d-flex gap-3 px-4 py-3 align-items-center text-dark hover-bg-light hover-text-primary transition-all"
                      >
                        <i class="fa fa-wrench" aria-hidden="true"></i>
                        Drone Service Centers
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                {/* hidden for payment gateway */}
                <div className="d-flex align-items-center">
                  <Link to="/jobs-hire-page">
                    <Dropdown>
                      <Dropdown.Toggle
                        className="bg-transparent border-0 change text-black fs_15"
                        id="dropdown-basic"
                      >
                        Careers
                      </Dropdown.Toggle>
                    </Dropdown>
                  </Link>
                </div>
                {/* <div className="d-flex align-items-center">
                  <Link to="/all-tenders">
                    <Dropdown>
                      <Dropdown.Toggle
                        className="bg-transparent border-0 change text-black fs_15"
                        id="dropdown-basic"
                      >
                        Insights/Blogs
                      </Dropdown.Toggle>
                    </Dropdown>
                  </Link>
                </div> */}

                {/* hidden for payment gateway */}
                <div className="d-flex align-items-center">
                  <Dropdown>
                    <Dropdown.Toggle
                      className="bg-transparent border-0 text-black fs_15 p-2 hover-underline"
                      id="dropdown-store"
                    >
                      Services
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="mt-2 p-2 border-0 shadow-lg rounded-3">
                      <Dropdown.Item
                        as={Link}
                        to="/daas-service-page"
                        className="d-flex gap-3 px-4 py-3 align-items-center text-dark hover-bg-light hover-text-primary transition-all"
                      >
                        <i className="fas fa-cog fs-6"></i>
                        DaaS
                      </Dropdown.Item>
                      <Dropdown.Item
                        as={Link}
                        to="/taas"
                        className="d-flex gap-3 px-4 py-3 align-items-center text-dark hover-bg-light hover-text-primary transition-all"
                      >
                        <i class="fa-solid fa-handshake"></i>
                        TaaS
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>

                {/* <div className="d-flex align-items-center">
                  <Link to="/daas-service-page">
                    <Dropdown>
                      <Dropdown.Toggle
                        className="bg-transparent border-0 change text-black fs_15"
                        id="dropdown-basic"
                      >
                        DaaS
                      </Dropdown.Toggle>
                    </Dropdown>
                  </Link>
                </div> */}
                {/* <div className="d-flex align-items-center">
                  <Link to="/taas">
                    <Dropdown>
                      <Dropdown.Toggle
                        className="bg-transparent border-0 change text-black fs_15"
                        id="dropdown-basic"
                      >
                        TaaS
                      </Dropdown.Toggle>
                    </Dropdown>
                  </Link>
                </div> */}
              </div>
              <div>
                <Button
                  aria-controls="account-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                  disableRipple
                  endIcon={
                    open ? (
                      <KeyboardArrowUp sx={{ transition: "transform 0.3s" }} />
                    ) : (
                      <KeyboardArrowDown
                        sx={{ transition: "transform 0.3s" }}
                      />
                    )
                  }
                  sx={{
                    whiteSpace: "nowrap",
                    color: "text.primary",
                    textTransform: "none",
                    ml: { xs: 0, sm: 2 },
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    minWidth: { xs: "auto", sm: "64px" },
                    px: { xs: 1, sm: 2 },
                    backgroundColor: "transparent",
                    "&:hover": {
                      backgroundColor: "transparent",
                      boxShadow: "none",
                      cursor: "pointer",
                    },
                    "& .MuiButton-endIcon": {
                      marginLeft: "4px",
                    },
                  }}
                >
                  {isLogin ? firstName : "Log In"}
                </Button>
                <StyledMenu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  PaperProps={{
                    sx: {
                      width: isMobile ? "90vw" : 550, //width 550 to 350 for payment gateway
                      p: 2,
                      borderRadius: 2,
                      boxShadow: 3,
                    },
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                >
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          color: "primary.main",
                          fontWeight: "bold",
                          mb: 1,
                        }}
                      >
                        Your Account
                      </Typography>
                      <Divider />
                      {!isLogin
                        ? [
                            ["login", "Log In/Sign Up", AccountCircle],
                            ["orders", "Your Orders", ShoppingBag],
                            ["account", "Your Account", AccountCircle],
                          ].map(([action, text, Icon]) => (
                            <MenuItem
                              key={action}
                              onClick={() => handleMenuClick(action)}
                              sx={{ py: 1, borderRadius: 1 }}
                            >
                              <Icon sx={{ mr: 2, fontSize: 20 }} />
                              {text}
                            </MenuItem>
                          ))
                        : [
                            ["account", "Your Account", AccountCircle],
                            ["orders", "Your Orders", ShoppingBag],
                            ["logout", "Log Out", ExitToApp],
                          ].map(([action, text, Icon]) => (
                            <MenuItem
                              key={action}
                              onClick={() => handleMenuClick(action)}
                              sx={{ py: 1, borderRadius: 1 }}
                            >
                              <Icon sx={{ mr: 2, fontSize: 20 }} />
                              {text}
                            </MenuItem>
                          ))}
                    </Grid>
                    {/* hidden for payment gateway */}
                    <Grid item xs={12} sm={6}>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          color: "primary.main",
                          fontWeight: "bold",
                          mb: 1,
                        }}
                      >
                        Partner Login
                      </Typography>
                      <Divider />
                      {[
                        ["/vendor-onboarding", "Vendor Forms", DescriptionIcon],
                        ["/aboutdaas", "DaasConnect", CloudQueue],
                        //['/taas', 'TaaS', Gravel],
                        // ['/enlist-new-drone', 'Sell Drone & Accessories', FlightTakeoff],
                        // ['/enlist-your-institute', 'Enlist your Institute', AppRegistration],
                        [
                          "/DroneXplore",
                          "DroneXplore",
                          MiscellaneousServicesIcon,
                        ],

                        [
                          "https://app.droneplanet.in",
                          "Partner Login",
                          ExitToApp,
                        ],
                      ].map(([to, text, Icon], index, arr) => (
                        <React.Fragment key={to}>
                          <MenuItem
                            component={to.startsWith("http") ? "a" : Link}
                            href={to.startsWith("http") ? to : undefined}
                            to={!to.startsWith("http") ? to : undefined}
                            rel="noopener"
                            sx={{ py: 1, borderRadius: 1 }}
                          >
                            <Icon sx={{ mr: 2, fontSize: 20 }} />
                            {text}
                          </MenuItem>
                          {text === "DroneXplore" && (
                            <Divider sx={{ backgroundColor: "black", my: 1 }} />
                          )}
                        </React.Fragment>
                      ))}
                    </Grid>
                  </Grid>
                </StyledMenu>
              </div>
              <div
                className="cart-icon cursor_pointer"
                style={{ marginLeft: "-10px" }}
              >
                <Link to="/cart">
                  <img src={CartIcon} alt="Cart" />
                  {isLogin && cartCount > 0 && (
                    <span className="cart-count">{cartCount}</span>
                  )}
                </Link>
              </div>
              <div
                className={`navmanu d-lg-none position-relative custom_zindex d-block burger ${sidebarVisible ? "active" : ""}`}
                style={{ marginLeft: "-20px" }}
                onClick={toggleSidebar}
              >
                <MenuIcon />
              </div>
            </div>
          </div>
          {sidebarVisible && (
            <StyledDrawer
              anchor="right"
              open={sidebarVisible}
              onClose={toggleSidebar}
              transitionDuration={300}
              ModalProps={{
                BackdropProps: {
                  transitionDuration: 300,
                },
              }}
              sx={{
                "& .MuiDrawer-paper": {
                  width: 280,
                  backgroundColor: "#fff",
                  transition:
                    "transform 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                },
              }}
            >
              <List sx={{ paddingTop: 3 }}>
                <ListItem
                  button
                  component={Link}
                  to="/"
                  onClick={toggleSidebar}
                  sx={{
                    "&:hover": { backgroundColor: "rgba(48, 140, 203, 0.1)" },
                    transition: "background-color 0.2s ease",
                  }}
                >
                  <ListItemIcon sx={{ color: "#308CCB" }}>
                    <Home />
                  </ListItemIcon>
                  <ListItemText
                    primary="Home"
                    primaryTypographyProps={{ color: "#000" }}
                  />
                </ListItem>
                <ListItem
                  button
                  onClick={() => setStoreOpen(!storeOpen)}
                  sx={{
                    "&:hover": { backgroundColor: "rgba(48, 140, 203, 0.1)" },
                    transition: "background-color 0.2s ease",
                  }}
                >
                  <ListItemIcon sx={{ color: "#308CCB" }}>
                    <Store />
                  </ListItemIcon>
                  <ListItemText primary="Marketplace" />
                  {storeOpen ? (
                    <ExpandLess sx={{ transition: "transform 0.2s ease" }} />
                  ) : (
                    <ExpandMore sx={{ transition: "transform 0.2s ease" }} />
                  )}
                </ListItem>
                <Collapse
                  in={storeOpen}
                  timeout="auto"
                  unmountOnExit
                  sx={{
                    transition: "all 0.3s ease",
                    transformOrigin: "top",
                  }}
                >
                  <List component="div" disablePadding>
                    <ListItem
                      button
                      component={Link}
                      to="/product/all-drone"
                      onClick={toggleSidebar}
                      sx={{
                        pl: 4,
                        "&:hover": {
                          backgroundColor: "rgba(48, 140, 203, 0.05)",
                        },
                      }}
                    >
                      <ListItemText
                        inset
                        primary="Buy Drones"
                        primaryTypographyProps={{ color: "#000" }}
                      />
                    </ListItem>
                    <ListItem
                      button
                      component={Link}
                      to="/drone-parts"
                      onClick={toggleSidebar}
                      sx={{
                        pl: 4,
                        "&:hover": {
                          backgroundColor: "rgba(48, 140, 203, 0.05)",
                        },
                      }}
                    >
                      <ListItemText
                        inset
                        primary="Buy Drone Parts"
                        primaryTypographyProps={{ color: "#000" }}
                      />
                    </ListItem>
                    <ListItem
                      button
                      component={Link}
                      to="/intellegence-market-solutions"
                      onClick={toggleSidebar}
                      sx={{
                        pl: 4,
                        "&:hover": {
                          backgroundColor: "rgba(48, 140, 203, 0.05)",
                        },
                      }}
                    >
                      <ListItemText
                        inset
                        primary="SaaS"
                        primaryTypographyProps={{ color: "#000" }}
                      />
                    </ListItem>
                    {/* <ListItem
                      button
                      component={Link}
                      to="/enlist-new-drone-page"
                      onClick={toggleSidebar}
                      sx={{ pl: 4, '&:hover': { backgroundColor: 'rgba(48, 140, 203, 0.05)' } }}
                    >
                      <ListItemText inset primary="Sell Drones & Parts" primaryTypographyProps={{ color: '#000' }} />
                    </ListItem> */}
                  </List>
                </Collapse>
                {/* hidden for payment gateway */}
                <ListItem
                  button
                  onClick={() => setTrainingOpen(!trainingOpen)}
                  sx={{
                    "&:hover": { backgroundColor: "rgba(48, 140, 203, 0.1)" },
                    transition: "background-color 0.2s ease",
                  }}
                >
                  <ListItemIcon sx={{ color: "#308CCB" }}>
                    <Flight />
                  </ListItemIcon>
                  <ListItemText primary="Training" />
                  {trainingOpen ? (
                    <ExpandLess sx={{ transition: "transform 0.2s ease" }} />
                  ) : (
                    <ExpandMore sx={{ transition: "transform 0.2s ease" }} />
                  )}
                </ListItem>
                <Collapse
                  in={trainingOpen}
                  timeout="auto"
                  unmountOnExit
                  sx={{
                    transition: "all 0.3s ease",
                    transformOrigin: "top",
                  }}
                >
                  <List component="div" disablePadding>
                    <ListItem
                      button
                      component={Link}
                      to="/training-courses/0"
                      onClick={toggleSidebar}
                      sx={{
                        pl: 4,
                        "&:hover": {
                          backgroundColor: "rgba(48, 140, 203, 0.05)",
                        },
                      }}
                    >
                      <ListItemText
                        inset
                        primary="Training Courses"
                        primaryTypographyProps={{ color: "#000" }}
                      />
                    </ListItem>
                    <ListItem
                      button
                      component={Link}
                      to="/training-courses/1"
                      onClick={toggleSidebar}
                      sx={{
                        pl: 4,
                        "&:hover": {
                          backgroundColor: "rgba(48, 140, 203, 0.05)",
                        },
                      }}
                    >
                      <ListItemText
                        inset
                        primary="Training Institutes"
                        primaryTypographyProps={{ color: "#000" }}
                      />
                    </ListItem>
                    <ListItem
                      button
                      component={Link}
                      to="/training-courses/2"
                      onClick={toggleSidebar}
                      sx={{
                        pl: 4,
                        "&:hover": {
                          backgroundColor: "rgba(48, 140, 203, 0.05)",
                        },
                      }}
                    >
                      <ListItemText
                        inset
                        primary="Deeptech Workshops"
                        primaryTypographyProps={{ color: "#000" }}
                      />
                    </ListItem>
                  </List>
                </Collapse>
                <ListItem
                  button
                  component={Link}
                  to="/jobs-hire-page"
                  onClick={toggleSidebar}
                  sx={{
                    "&:hover": { backgroundColor: "rgba(48, 140, 203, 0.1)" },
                    transition: "background-color 0.2s ease",
                  }}
                >
                  <ListItemIcon sx={{ color: "#308CCB" }}>
                    <Work />
                  </ListItemIcon>
                  <ListItemText
                    primary="Careers"
                    primaryTypographyProps={{ color: "#000" }}
                  />
                </ListItem>

                <ListItem
                  button
                  component={Link}
                  to="/dsk"
                  onClick={toggleSidebar}
                  sx={{
                    "&:hover": { backgroundColor: "rgba(48, 140, 203, 0.1)" },
                    transition: "background-color 0.2s ease",
                  }}
                >
                  <ListItemIcon sx={{ color: "#308CCB" }}>
                    <Work />
                  </ListItemIcon>
                  <ListItemText
                    primary="DSK"
                    primaryTypographyProps={{ color: "#000" }}
                  />
                </ListItem>

                <ListItem
                  button
                  component={Link}
                  to="/drone-city"
                  onClick={toggleSidebar}
                  sx={{
                    "&:hover": { backgroundColor: "rgba(48, 140, 203, 0.1)" },
                    transition: "background-color 0.2s ease",
                  }}
                >
                  <ListItemIcon sx={{ color: "#308CCB" }}>
                    <PiDroneFill />
                  </ListItemIcon>
                  <ListItemText
                    primary="Drone City"
                    primaryTypographyProps={{ color: "#000" }}
                  />
                </ListItem>

                <ListItem
                  button
                  onClick={() => setServiceOpen(!serviceOpen)}
                  sx={{
                    "&:hover": { backgroundColor: "rgba(48, 140, 203, 0.1)" },
                    transition: "background-color 0.2s ease",
                  }}
                >
                  <ListItemIcon sx={{ color: "#308CCB" }}>
                    <Settings />
                  </ListItemIcon>
                  <ListItemText primary="Services" />
                  {serviceOpen ? (
                    <ExpandLess sx={{ transition: "transform 0.2s ease" }} />
                  ) : (
                    <ExpandMore sx={{ transition: "transform 0.2s ease" }} />
                  )}
                </ListItem>
                <Collapse
                  in={serviceOpen}
                  timeout="auto"
                  unmountOnExit
                  sx={{
                    transition: "all 0.3s ease",
                    transformOrigin: "top",
                  }}
                >
                  <List component="div" disablePadding>
                    <ListItem
                      button
                      component={Link}
                      to="/daas-service-page"
                      onClick={toggleSidebar}
                      sx={{
                        pl: 4,
                        "&:hover": {
                          backgroundColor: "rgba(48, 140, 203, 0.05)",
                        },
                      }}
                    >
                      <ListItemText
                        inset
                        primary="DaaS"
                        primaryTypographyProps={{ color: "#000" }}
                      />
                    </ListItem>
                    <ListItem
                      button
                      component={Link}
                      to="/taas"
                      onClick={toggleSidebar}
                      sx={{
                        pl: 4,
                        "&:hover": {
                          backgroundColor: "rgba(48, 140, 203, 0.05)",
                        },
                      }}
                    >
                      <ListItemText
                        inset
                        primary="TaaS"
                        primaryTypographyProps={{ color: "#000" }}
                      />
                    </ListItem>
                  </List>
                </Collapse>
                {/* <ListItem
                  button
                  component={Link}
                  to="/daas-service-page"
                  onClick={toggleSidebar}
                  sx={{
                    '&:hover': { backgroundColor: 'rgba(48, 140, 203, 0.1)' },
                    transition: 'background-color 0.2s ease'
                  }}
                >
                  <ListItemIcon sx={{ color: '#308CCB' }}><Explore /></ListItemIcon>
                  <ListItemText primary="Daas Services/Projects" primaryTypographyProps={{ color: '#000' }} />
                </ListItem> */}
                <ListItem
                  button
                  component={Link}
                  to="/Cart"
                  onClick={toggleSidebar}
                  sx={{
                    "&:hover": { backgroundColor: "rgba(48, 140, 203, 0.1)" },
                    transition: "background-color 0.2s ease",
                  }}
                >
                  <ListItemIcon sx={{ color: "#308CCB" }}>
                    <ShoppingCart />
                  </ListItemIcon>
                  <ListItemText
                    primary="Cart"
                    primaryTypographyProps={{ color: "#000" }}
                  />
                </ListItem>
                <Divider sx={{ my: 2 }} />
                {!isLogin ? (
                  <ListItem>
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      startIcon={<Login />}
                      onClick={() => {
                        dispatch(handleLoginPopup(true));
                        toggleSidebar();
                      }}
                      sx={{
                        transition: "all 0.2s ease",
                        "&:hover": {
                          transform: "translateY(-2px)",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                        },
                      }}
                    >
                      Log In
                    </Button>
                  </ListItem>
                ) : (
                  <>
                    <ListItem>
                      <Button
                        fullWidth
                        variant="outlined"
                        color="error"
                        startIcon={<Logout />}
                        onClick={() => {
                          Cookies.remove("token");
                          window.location.reload();
                        }}
                        sx={{
                          transition: "all 0.2s ease",
                          "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                          },
                        }}
                      >
                        Logout
                      </Button>
                    </ListItem>
                  </>
                )}
                {/* hidden for payment gateway */}
                <ListItem>
                  <Button
                    fullWidth
                    variant="outlined"
                    onClick={() =>
                      window.open("https://app.droneplanet.in", "_blank")
                    }
                    sx={{
                      transition: "all 0.2s ease",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                      },
                    }}
                  >
                    Partner Login
                  </Button>
                </ListItem>
              </List>
            </StyledDrawer>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
